var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { padding: "40px" } },
    [
      _c("h2", [_vm._v("第三方设备模拟器（TUICallEngine 方式）")]),
      _c(
        "el-form",
        { attrs: { "label-width": "120px" } },
        [
          _c(
            "el-form-item",
            { attrs: { label: "SDKAppID" } },
            [
              _c("el-input", {
                model: {
                  value: _vm.form.sdkAppID,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "sdkAppID", $$v)
                  },
                  expression: "form.sdkAppID",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "第三方UserID" } },
            [
              _c("el-input", {
                attrs: { placeholder: "如 device_001" },
                model: {
                  value: _vm.form.fromUserId,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "fromUserId", $$v)
                  },
                  expression: "form.fromUserId",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "医生UserID" } },
            [
              _c("el-input", {
                attrs: { placeholder: "接收方医生的 baseUserId" },
                model: {
                  value: _vm.form.toUserId,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "toUserId", $$v)
                  },
                  expression: "form.toUserId",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "患者编码" } },
            [
              _c("el-input", {
                model: {
                  value: _vm.form.patientCode,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "patientCode", $$v)
                  },
                  expression: "form.patientCode",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "诊断编码" } },
            [
              _c("el-input", {
                model: {
                  value: _vm.form.diagRecordCode,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "diagRecordCode", $$v)
                  },
                  expression: "form.diagRecordCode",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.login } },
                [_vm._v("登录 TUICallEngine")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "success", disabled: !_vm.isLogin },
                  on: { click: _vm.callVideo },
                },
                [_vm._v("发起视频呼叫")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }